import React from 'react'
import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import MailgunLogo from '../../../assets/svg/Mailgun Symbol.svg'
import Button from '../../Button'
import Img from 'gatsby-image'

const StyledCard = styled.div`
  align-items: flex-end;
  align-self: ${({ position }) => position};
  border-radius: 8px;
  display: ${({ mobileDisabled }) => (mobileDisabled ? 'none' : 'flex')};
  grid-column: ${({ start }) => start} / ${({ width, start }) => width + start};
  margin-bottom: 24px;
  min-height: 150px;
  overflow: hidden;
  width: ${({ maxWidth }) => maxWidth};

  .gatsby-image-wrapper {
    border-radius: 8px;
    height: 100%;
    overflow: hidden;
    width: 100%;
  }

  ${({ theme }) => theme.media.desktop} {
    display: block;
    margin-bottom: 0;
    width: 100%;
  }
`

const StyledRedCard = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.red};
  display: flex;
  flex-direction: column;
  height: 336px;
  justify-content: center;
  position: relative;
  width: 100%;

  h1, a {
    z-index: 2000;
  }

  a {
    background-color: #fff;
    color: ${({ theme }) => theme.colors.red};
    font-size: 14px;
    font-weight: 500;
    padding: 8px 40px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
`
const StyledCardBackground = styled(SVG)`
  left: 0;
  position: absolute;
  top: 0;
`
const StyledCardTitle = styled.h1`
  color: #fff;
  font-size: 1.75em;
  font-weight: 500;
  margin-bottom: 24px;
  text-align: center;
  width: 70%;
`

const Card = ({ cardData, mobileDisabled }) => {
  if (cardData.type === 'image') {
    return (
      <StyledCard
        maxWidth="100%"
        mobileDisabled={mobileDisabled}
        position={cardData.position}
        start={cardData.start}
        width={cardData.width}
      >
        <Img fluid={cardData.img} />
        {/* <Image imgName={cardData.imgName} /> */}
      </StyledCard>
    )
  } else {
    return (
      <StyledCard
        position={cardData.position}
        width={cardData.width}
        start={cardData.start}
        maxWidth="100%"
      >
        <StyledRedCard>
          <StyledCardBackground src={MailgunLogo} />
          <StyledCardTitle>{cardData.text}</StyledCardTitle>
          <Button external={true} to={cardData.button.link}>{cardData.button.text}</Button>
        </StyledRedCard>
      </StyledCard>
    )
  }
}

export default Card
